import { DynamicFormField } from '../dynamic-form-field.model';
import { DynamicFormFieldConfig } from '../dynamic-form-field-config.model';
import { FormArray, FormGroup } from '@angular/forms';
import { DynamicDateFieldComponent } from '../../../components/dynamic-form/dynamic-form-field';

export class DateField extends DynamicFormField {
  constructor(config: DynamicFormFieldConfig, parentForm: FormGroup | FormArray) {
    super(config, parentForm);
    this.component = DynamicDateFieldComponent;
  }

  static override create(config: DynamicFormFieldConfig, parentForm: FormGroup | FormArray) {
    return new DateField(config, parentForm);
  }
}
